import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import StickyHeader from "../../../components/Layout/StickyHeader";
import CommonButton from "../../../components/Button";

type Props = {};

export default function ServiceNotFound(props: Props) {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="px-5 w-full bg-white">
        <StickyHeader title="미지원 서비스" onBackClick={() => navigate("/")} />
      </div>
      <div className="px-5 h-screen z-30 bg-white w-full">
        <div className="flex flex-col items-center justify-center h-full">
          <div className="flex flex-col items-center gap-4">
            <div className="flex flex-col p-5 py-7 items-center text-center">
              지원하지 않는 서비스입니다.
            </div>
            <div className="flex flex-row gap-2 py-5">
              <CommonButton
                className="border border-gray-200 h-bottom-button min-w-[100px]"
                variant="white"
                title="뒤로 가기"
                onClick={() => navigate(-1)}
              >
                뒤로 가기
              </CommonButton>
              <CommonButton
                className="border border-gray-200 h-bottom-button min-w-[100px]"
                variant="primary"
                title="홈으로 가기"
                onClick={() => navigate("/")}
              >
                홈으로
              </CommonButton>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
